import { GetListParams } from 'react-admin';
import { CustomDataProvider } from '../../../providers/CustomDataProvider';
import { baseUrl, httpClient } from '../../../providers/AppDataProvider';

export class RewardClaimsDataProvider implements CustomDataProvider {
  // eslint-disable-next-line class-methods-use-this
  async getList(_resource: string, params: GetListParams): Promise<any> {
    const { page, perPage } = params.pagination || {};
    const searchParams = new URLSearchParams();
    if (page) searchParams.set('page', String(page));
    if (perPage) searchParams.set('pageSize', String(perPage));

    const query = searchParams.toString();
    const url = `${baseUrl}/agent-reward-claims${query ? `?${query}` : ''}`;

    const { json } = await httpClient(url);
    const items: any[] = json?.items ?? [];
    const total = json?.total ?? items.length;

    return { data: items, total };
  }
}

export const rewardClaimsDataProvider = new RewardClaimsDataProvider();
